import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { AutomationEvent } from "./automation-event";

export class Automation extends Resource {
    public override type = 'automations';

    @prop()
    public name!: string;

    @prop()
    public automationEventId!: string;
    public automationEvent!: AutomationEvent;

    @prop()
    public enabled : boolean = true;
    
    @prop()
    public eventConfig!: any;
    
}